import { defineComponent as p, openBlock as a, createElementBlock as o, mergeProps as u, unref as l, renderSlot as V, createElementVNode as e, createCommentVNode as g } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, f = { key: 2 }, h = { key: 3 }, H = { key: 4 }, L = { key: 5 }, k = {
  name: "ScalarIconArrowLineRight"
}, y = /* @__PURE__ */ p({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = M(s);
    return (i, t) => (a(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      V(i.$slots, "default"),
      l(n) === "bold" ? (a(), o("g", Z, t[0] || (t[0] = [
        e("path", { d: "M184.49,119.51a12,12,0,0,1,0,17l-72,72a12,12,0,0,1-17-17L147,140H32a12,12,0,0,1,0-24H147L95.51,64.49a12,12,0,0,1,17-17ZM216,28a12,12,0,0,0-12,12V216a12,12,0,0,0,24,0V40A12,12,0,0,0,216,28Z" }, null, -1)
      ]))) : l(n) === "duotone" ? (a(), o("g", m, t[1] || (t[1] = [
        e("path", {
          d: "M184,128l-72,72V56Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M117.66,50.34A8,8,0,0,0,104,56v64H32a8,8,0,0,0,0,16h72v64a8,8,0,0,0,13.66,5.66l72-72a8,8,0,0,0,0-11.32ZM120,180.69V75.31L172.69,128ZM224,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : l(n) === "fill" ? (a(), o("g", f, t[2] || (t[2] = [
        e("path", { d: "M224,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM117.66,50.34A8,8,0,0,0,104,56v64H32a8,8,0,0,0,0,16h72v64a8,8,0,0,0,13.66,5.66l72-72a8,8,0,0,0,0-11.32Z" }, null, -1)
      ]))) : l(n) === "light" ? (a(), o("g", h, t[3] || (t[3] = [
        e("path", { d: "M188.24,123.76a6,6,0,0,1,0,8.48l-72,72a6,6,0,0,1-8.48-8.48L169.51,134H32a6,6,0,0,1,0-12H169.51L107.76,60.24a6,6,0,0,1,8.48-8.48ZM216,34a6,6,0,0,0-6,6V216a6,6,0,0,0,12,0V40A6,6,0,0,0,216,34Z" }, null, -1)
      ]))) : l(n) === "regular" ? (a(), o("g", H, t[4] || (t[4] = [
        e("path", { d: "M189.66,122.34a8,8,0,0,1,0,11.32l-72,72a8,8,0,0,1-11.32-11.32L164.69,136H32a8,8,0,0,1,0-16H164.69L106.34,61.66a8,8,0,0,1,11.32-11.32ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z" }, null, -1)
      ]))) : l(n) === "thin" ? (a(), o("g", L, t[5] || (t[5] = [
        e("path", { d: "M186.83,125.17a4,4,0,0,1,0,5.66l-72,72a4,4,0,0,1-5.66-5.66L174.34,132H32a4,4,0,0,1,0-8H174.34L109.17,58.83a4,4,0,0,1,5.66-5.66ZM216,36a4,4,0,0,0-4,4V216a4,4,0,0,0,8,0V40A4,4,0,0,0,216,36Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  y as default
};
